import { Widget, WidgetHeader } from './shared';
import t from '../../../util/translation/translation';
import React, { useEffect, useState } from 'react';
import ScheduledMessages from '../../../containers/questionaires/components/QuestionaireDashboardWidget.jsx';
import { Link } from 'react-router-dom';
const UpcomingQuizes = () => {
  const [questionairesLoading, setQuestionairesLoading] = useState(true);

  return (
    <Widget>
      <WidgetHeader
        bottomSpace="sm"
        title={t('DashboardPage.upcomingQuizes')}
        subhead={''}
      >
        <Link to="/questionnaires" className="events-link">
          {t('DashboardPage.viewAll')}
        </Link>
      </WidgetHeader>
      <ScheduledMessages setLoading={setQuestionairesLoading} />
    </Widget>
  );
};

export default UpcomingQuizes;
